import type { SVGProps } from 'react';
const SvgMailSendEnvelopeStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M1.982 2.643h14.536a1.321 1.321 0 0 1 1.321 1.321v10.572a1.321 1.321 0 0 1-1.321 1.321H1.982a1.321 1.321 0 0 1-1.321-1.321V3.964a1.321 1.321 0 0 1 1.321-1.321Z" />
      <path d="M.661 3.964 9.25 9.911l8.589-5.947" />
    </g>
  </svg>
);
export default SvgMailSendEnvelopeStreamlineCore;
